import React from "react";
import { useTranslation } from "react-i18next";
import "@/assets/styles/Utils.css";
import "./FeedbackForm.css";

const SCALE_MIN = 0;
const SCALE_MAX = 10;

/**
 * The feedback step: one question, one value, one optional message.
 *
 * The scale runs from bad to good and always has — 10 is the good end. The
 * stored field is `program_session[pain_level]`, which reads like the
 * opposite; the therapist side used to label it "Schmerz" and so showed every
 * answer upside down. The wording on both sides now says well-being, because
 * that is what patients have actually been answering: turning the scale
 * around instead would have made every recorded session mean the opposite of
 * what it meant when it was recorded.
 *
 * One question for every program, deliberately. A question that changed with
 * the program's goal would land in the same single number, and nobody reading
 * it later could tell which question had been asked.
 */
export function FeedbackForm({
  feedbackLvl,
  setLvl,
  feedbackText,
  setFeedbackText,
  onSubmit,
  submitLabel,
  showTitle = true,
  showSubmit = true,
}) {
  const { t } = useTranslation();
  const value = Number(feedbackLvl);
  const progress = ((value - SCALE_MIN) / (SCALE_MAX - SCALE_MIN)) * 100;

  return (
    <div className="fb-form">
      {showTitle && <h4 className="fb-title">{t("feedback.feedback")}</h4>}

      <div className="fb-scale">
        <label className="fb-question" htmlFor="feedback-level">
          {t("feedback.target")}
        </label>

        <div className="fb-value" aria-hidden="true">
          <b>{value}</b>
          <span>/ {SCALE_MAX}</span>
        </div>

        <input
          id="feedback-level"
          type="range"
          className="fb-range"
          min={SCALE_MIN}
          max={SCALE_MAX}
          step="1"
          value={feedbackLvl}
          style={{ "--fb-progress": `${progress}%` }}
          onChange={(e) => setLvl(e.target.value)}
          aria-valuetext={`${value} / ${SCALE_MAX}`}
        />

        <div className="fb-ends">
          <span>{t("feedback.bad")}</span>
          <span>{t("feedback.good")}</span>
        </div>
      </div>

      <textarea
        className="fb-note"
        rows={3}
        placeholder={t("feedback.placeholder")}
        value={feedbackText}
        onChange={(e) => setFeedbackText(e.target.value)}
      />

      {showSubmit && (
        <button type="button" className="fb-submit" onClick={onSubmit}>
          {submitLabel || t("actions.send")}
        </button>
      )}
    </div>
  );
}
